// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SecurityIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SecurityIcon" ref={forwardedRef} {...props}>
      <path d="M16.5 4.764a1 1 0 0 0-.835-.987L14.14 3.523a6 6 0 0 1-1.697-.551L10 1.75 7.155 3.173A3 3 0 0 1 6.306 3.45l-1.97.328a1 1 0 0 0-.835.987v7.048a5 5 0 0 0 2.916 4.546L10.001 18l3.583-1.642a5 5 0 0 0 2.917-4.546zM10 16.35l-2.958-1.356a3.5 3.5 0 0 1-2.041-3.182V5.187L6.553 4.93a4.5 4.5 0 0 0 1.273-.414L10 3.427l1.772.886a7.5 7.5 0 0 0 2.12.69L15 5.187v6.625a3.5 3.5 0 0 1-2.042 3.182z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SecurityIcon = /* @__PURE__ */ Object.assign(
  SecurityIconComponent,
  { displayName: 'SecurityIcon' },
);
